import { useProductImageQuery } from '../../graphql';
import { Image } from './Image';

import styled from 'styled-components';

const FavoriteProduct = ({
	selected,
	onClick,
	productId,
	productName
}: FavoriteProductProps): JSX.Element => {
	const { data, error, loading } = useProductImageQuery({
		variables: { productId: productId as string }
	});

	return (
		<ProductCard onClick={onClick}>
			{error && <span>{error.message}</span>}
			{loading && <span>{loading}</span>}
			<Image
				selected={selected}
				isCircle
				source={data?.product?.image as string}
			/>
			<br />
			<span
				style={{
					color: selected ? '#f47920' : 'inherit',
					textAlign: 'center',
					lineHeight: '100%'
				}}
			>
				{productName}
			</span>
		</ProductCard>
	);
};

export default FavoriteProduct;

interface FavoriteProductProps {
	selected: boolean;
	onClick: () => void;
	productId: string | number;
	productName: string;
}

const ProductCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 120px;
	&:hover {
		cursor: pointer;
	}
`;
